import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, TrendingUp } from "lucide-react";
import { HERO } from "@/content/landing";

// Le hero s'anime en CSS pur (voir .hero-anim) : visible même si le JS
// d'animation ne tourne pas (onglet en arrière-plan, prérendu, etc.).
export default function Hero() {
  const max = Math.max(...HERO.visual.bars);
  return (
    <section className="hero">
      <div className="hero-copy">
        <span className="eyebrow hero-anim" style={{ "--i": 0 }}>{HERO.eyebrow}</span>
        <h1 className="hero-anim" style={{ "--i": 1 }}>{HERO.title}</h1>
        <p className="hero-lead hero-anim" style={{ "--i": 2 }}>{HERO.lead}</p>
        <div className="hero-actions hero-anim" style={{ "--i": 3 }}>
          <Link to={HERO.ctaPlayer.to} className="button button-dark" data-testid="landing-hero-player">{HERO.ctaPlayer.label}<ArrowRight size={14} /></Link>
          <Link to={HERO.ctaCoach.to} className="button button-outline" data-testid="landing-hero-coach">{HERO.ctaCoach.label}</Link>
        </div>
        <p className="hero-note hero-anim" style={{ "--i": 4 }}>{HERO.note}</p>
      </div>

      <div className="hero-visual hero-anim" style={{ "--i": 3 }} aria-hidden="true">
        <div className="hero-card">
          <div className="hero-card-head"><span>Votre progression</span><span className="hero-card-range">30 derniers jours</span></div>
          <div className="hero-stats">
            {HERO.visual.stats.map(s => (
              <div key={s.label} className="hero-stat">
                <span className="hero-stat-label">{s.label}</span>
                <strong>{s.value}</strong>
                <small><TrendingUp size={10} />{s.delta}</small>
              </div>
            ))}
          </div>
          <div className="hero-bars">
            {HERO.visual.bars.map((b, i) => <i key={i} style={{ height: `${(b / max) * 100}%` }} className={i === HERO.visual.bars.length - 1 ? "is-last" : undefined} />)}
          </div>
        </div>
        <div className="hero-card hero-card-next">
          <span className="hero-stat-label">{HERO.visual.next.title}</span>
          <div className="hero-next-row"><span className="hero-next-icon"><CalendarDays size={15} /></span><div><strong>{HERO.visual.next.coach}</strong><small>{HERO.visual.next.when}</small></div></div>
        </div>
      </div>
    </section>
  );
}
